import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sgzp-app2register-send',
  templateUrl: './sgzp-app2-register-send.component.html',
  styleUrls: ['./sgzp-app2-register-send.component.css', '../style/global.css'],
})
export class SgzpApp2RegisterSendComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  @Input()
  clientId: string;
  email: string;
  constructor(
    title: Title,
    private http: HttpClient,
    private spinner: NgxSpinnerService
  ) {
    super();
    title.setTitle('認証メール送信完了');
  }

  get baseLink() {
    return environment.apps[this.clientId].appUrl;
  }
  ngOnInit(): void {
    this.email = sessionStorage.getItem(sessionStorageKey.verifyEmail);
    // 遷移元
    const verifyEmailReferer = sessionStorage.getItem(
      sessionStorageKey.verifyEmailReferer
    ) as 'login';
    if (!this.email) {
      history.back();
      return;
    }
    if (this.email && verifyEmailReferer === 'login') {
      sessionStorage.removeItem(sessionStorageKey.verifyEmailReferer);
      this.http
        .post(
          `https://${environment.domain}/management/api/v1/auth/verification-email`,
          {
            client_id: this.clientId,
            email: this.email,
          }
        )
        .subscribe((resp: { result: boolean }) => {
          if (!resp.result) {
            return;
          }
        });
    }
  }

  async submit() {
    location.pathname = 'register-resend';
  }

  async toLogin() {
    location.pathname = 'login';
  }
}
